import { camelize } from '@ember/string';

export default {
  sortable: function (resourceName, getSortFieldValue = this._getSortFieldValue) {
    return (schema, request) => {
      const sorted = schema[resourceName].all();
      if (!request.queryParams['sort']) {
        // return all the data if there is no sort parameters
        return sorted;
      }
      const isDesc = request.queryParams['sort'].startsWith('-');
      const sortField = camelize(request.queryParams['sort']);
      sorted.models.sort((a, b) => {
        if (getSortFieldValue(a, sortField) < getSortFieldValue(b, sortField)) {
          return isDesc ? 1 : -1;
        } else if (getSortFieldValue(a, sortField) > getSortFieldValue(b, sortField)) {
          return isDesc ? -1 : 1;
        }
        return 0;
      });
      return sorted;
    };
  },

  _getSortFieldValue: function (object, field) {
    return object[field];
  },
};
